import React from "react";

// Tarjetas de métricas del mes. "progreso" (0-100) es opcional — cuando viene, pinta una
// barra debajo del valor (usada por la métrica de Avance)
export const VisitasMetricas = ({ metricas }) => {
  return (
    <div className="vp-metricas">
      {metricas.map((m) => (
        <div key={m.label} className="vp-metrica" style={{ borderLeftColor: m.color }}>
          <div className="vp-metrica-label">{m.label}</div>
          <div className="vp-metrica-valor">{m.valor}</div>
          {m.progreso != null && (
            <div className="vp-metrica-barra">
              <div className="vp-metrica-barra-fill" style={{ width: `${m.progreso}%`, background: m.color }} />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
